import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { AsyncReduxState, initialAsyncReduxState } from '../../defaults';

export type ActiveCartState = AsyncReduxState<{
    activeCartToken: string;
}>;

const initialState: ActiveCartState = {
    ...initialAsyncReduxState,
    activeCartToken: '',
};

const activeCartSlice = createSlice({
    name: 'activeCartSlice',
    initialState,
    reducers: {
        setIsLoading(state, action: PayloadAction<boolean>): ActiveCartState {
            return {
                ...state,
                isLoading: action.payload,
            };
        },
        setHasFetched(state, action: PayloadAction<boolean>): ActiveCartState {
            return {
                ...state,
                hasFetched: action.payload,
            };
        },
        setIsSuccessful(state, action: PayloadAction<boolean>): ActiveCartState {
            return {
                ...state,
                isSuccessful: action.payload,
            };
        },
        setError(state, action: PayloadAction<string>): ActiveCartState {
            return {
                ...state,
                error: action.payload,
            };
        },
        setActiveCartToken(state, action: PayloadAction<string>): ActiveCartState {
            return {
                ...state,
                activeCartToken: action.payload,
            };
        },
    },
});

export const {
    setIsLoading,
    setHasFetched,
    setIsSuccessful,
    setError,
    setActiveCartToken,
} = activeCartSlice.actions;

export default activeCartSlice;
